<section [matMenuTriggerFor]="menu" class="menu">
  <a
    [ngClass]="{
      'white-label': isHomeRoute() || darkNavBar(),
      'black-label': !(isHomeRoute() || darkNavBar())
    }"
    class="label"
  >
    {{ label }}
  </a>
  <p class="bursary-funds-arrow-container">
    <mat-icon class="bursary-funds-arrow"> expand_more </mat-icon>
  </p>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent>
      @if (isLoading) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        @for (item of getMenuItems(); track trackByFn($index, item)) {
          <button mat-menu-item (click)="navigate(item)">
            {{ item.label }}
          </button>
        }
      }
    </ng-template>
  </mat-menu>
</section>
